import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { SetupPresetGroupType } from '@/media/entity/SetupPresetGroup';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import { METRIC_DATA_DECORATOR_FANCY } from '@/metric/constants/dataDecorators';
import Diamond from '@/product/entity/Diamond';

export const FIELD_SHAPE_NORMALIZED_PERFORMANCE_V2: Field = {
  key: 'integralV2.smc',
  label: 'Shape Norm. Perf. v2 (Beta)',
  fullLabel: 'Shape Normalized Performance v2 (Beta)',
  type: FieldType.Metric,
  spGroupId: SetupPresetGroupType.FireDiBOX,
  hasAbsoluteValue: true,
  isShortTitleInCombo: true,
  icon: 'metrics-normalized–cut-perf',
  getValue(p) {
    if (p instanceof Diamond && p.integralV2Metric) {
      return p.integralV2Metric.val;
    }

    return null;
  },
  getText(p) {
    if (p instanceof Diamond && p.integralV2Metric) {
      return p.integralV2Metric.shape.hr;
    }

    return null;
  },
  render(p, { ratio, size, label, icon, isMetricInCard } = {}) {
    if (p instanceof Diamond) {
      return (
        <OptMetricBar
          cutShapeId={p.cutShapeId}
          metric={p.integralV2Metric}
          metricDataDecorator={METRIC_DATA_DECORATOR_FANCY}
          ratio={ratio}
          type="integralV2"
        >
          {(scale, abs) => (
            <MetricScaleContainer
              abs={abs}
              icon={icon}
              inCard={isMetricInCard}
              isMetricCalculated={Boolean(p.integralV2Metric)}
              label={label}
              scale={scale}
              size={size}
            />
          )}
        </OptMetricBar>
      );
    }

    return null;
  },
  iteratee(p) {
    if (p instanceof Diamond && p.integralV2Metric) {
      return p.integralV2Metric.smc;
    }

    return null;
  },
  contexts: ALL_CONTEXTS,
};
